import React, { useEffect } from 'react';
import styled from 'styled-components';
import { CheckboxInput } from '../forms/CheckboxInput';
import { useGetUsersByLicense, useSearchUserContext } from '../user-management';
import { useLicenseAssignment } from './LicenseAssignmentContext';
import { LicenseCountPerUser } from './LicenseCountPerUser';

// TODO: investigate if className is needed
interface UserListProps {
  className?: string;
}
const LicenseUserList: React.FC<UserListProps> = ({ className = '' }) => {
  const { setSelectedUsers, selectedUsers, selectUser, unselectUser } = useLicenseAssignment();

  const { licenseId } = useLicenseAssignment();
  const { usersAssigned } = useGetUsersByLicense(licenseId);

  useEffect(() => {
    setSelectedUsers(usersAssigned);
  }, [setSelectedUsers, usersAssigned]);

  const { foundUsers } = useSearchUserContext();
  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setSelectedUsers(foundUsers.map(({ id }) => id));
    } else {
      setSelectedUsers([]);
    }
  };

  return (
    <div className={className}>
      <table>
        <tbody>
          <tr>
            <th>
              <CheckboxInput
                label='All'
                onChange={handleSelectAll}
                checked={foundUsers.length === selectedUsers.length}
              />
            </th>
            <th>Allocated Licenses</th>
          </tr>
          {foundUsers.map((user) => {
            return (
              <tr className='userRow' key={user.id}>
                <td>
                  <CheckboxInput
                    className='foo'
                    label={user.email}
                    checked={selectedUsers.includes(user.id)}
                    onChange={(event) =>
                      event.target.checked ? selectUser(user.id) : unselectUser(user.id)
                    }
                  />
                </td>
                <td>
                  <LicenseCountPerUser userId={user.id} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export const StyledLicenseUserList = styled(LicenseUserList)`
  height: 200px;
  max-height: 200px;
  overflow-y: auto;
  padding: 8px;

  table {
    display: table;
    padding-right: 12px;
    width: 100%;

    tr {
      &:first-of-type {
        border-bottom: 1px solid #000;
      }
    }

    th {
      padding-bottom: 8px;
    }

    th,
    td {
      font-size: 1.1em;
      font-weight: bold;
      text-align: left;
      padding-right: 32px;

      &:last-of-type {
        padding-right: 16px;
      }
    }
  }
`;
